
    import Vue from 'vue';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import ivaConditionService from '@/apps/shared/services/ivaConditions-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import localityService from '@/apps/shared/services/locality-service';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';

    const GROUP_LABELS = {
        under21: 'Menores a 21 años',
        between21And75: 'Entre 21 y 75 años',
        over75: 'Entre 75 años y 84 años',
    };

    const MAX_PASSENGER_AGE = 84;
    const MAX_PASSENGER_AGE_MESSAGE = `El pasajero no puede tener más de ${MAX_PASSENGER_AGE} años a la fecha de regreso del viaje.`;

    export default Vue.extend({
        components: { WhatsApp, XBreadcrumb },
        name: 'TravelAssistancePassengers',
        data() {
            return {
                breadcrumbItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Pasajeros', path: '/asistencia-viajero/pasajeros' },
                ],
                localityList: function (params) { return localityService.getLocalityList(params) },
                minimumInputLength: 4,
                streetName: null,
                numDom: null,
                selectedLocality: null,
                piso: null,
                numDept: null,
                hasLocality: false,
                planDescription: '',
                planPrice: '',
                planPriceArs: '',
                covers: [],
                showAddInsuredButton: true,
                contractorTraveling: false,
                beneficiaries: null,
                maxSelections: 2,
                documentTypeList: [{ id: "", text: "" }],
                ivaConditionList: [{ id: "", text: "" }],
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                isNotSelectedDocumentType: true,
                nextButtonDisable: true,
                addPeopleDisable: false,
                addPeopleDisableTooltipText: "",
                messageErrorAge: null,
                insuredPeople: [],
                rolRelations: { id: 1, name: "Pasajero" },
                personToAdd: {},
                beneficiaryData: {},
                searchButtonDisable: true,
                personToAddDocTypeSelected: null,
                personToAddNumDoc: null,
                policyOwner: null,
                numDocChange: null,
                numDocExisting: null,
                personToDelete: {},
                isPerson: false,
                isJuridico: false,
                multiplePeopleWithSameIdentifier: [],
                personWithSameIdentifierSelected: null,
                isBeneficiaryMode: false,
                currentBeneficiaryItem: null,
                multiplePeopleError: "",
                personNotExist: false,
                peopleToCoverHasLocality: true,
                personData: null,
                hasBeneficiaryAddress: false,
                isPeopleWithSameIdentifierModalOpen: false,
                personFound: false,
                cuposDeclarados: { under21: 0, between21And75: 0, over75: 0 },
                tripEndDate: null,
                groupOfContractor: null,
                referente: null,
            };
        },
        computed: {
            passengerGroups() {
                return Object.keys(this.cuposDeclarados)
                    .filter(key => this.cuposDeclarados[key] > 0)
                    .map(key => ({ key, label: GROUP_LABELS[key] }));
            },
            cargadosPorGrupo() {
                const result = { under21: 0, between21And75: 0, over75: 0 };
                this.insuredPeople.forEach(p => {
                    const group = this.getAgeGroup(p.birthday);
                    if (group) result[group]++;
                });
                return result;
            },
            cuposRestantes() {
                return {
                    under21: this.cuposDeclarados.under21 - this.cargadosPorGrupo.under21,
                    between21And75: this.cuposDeclarados.between21And75 - this.cargadosPorGrupo.between21And75,
                    over75: this.cuposDeclarados.over75 - this.cargadosPorGrupo.over75,
                };
            },
            totalCupoRestante() {
                return this.cuposRestantes.under21 + this.cuposRestantes.between21And75 + this.cuposRestantes.over75;
            },
            totalPassengersDeclared() {
                return this.cuposDeclarados.under21 + this.cuposDeclarados.between21And75 + this.cuposDeclarados.over75;
            },
        },
        created() {
            this.personToDelete = this.getDefaultPerson();
            this.personToAdd = this.getDefaultPersonToAdd();

            window.globalThis.validateNumDoc = (val) => {
                let valid = true;
                let message = "";

                if (!this.personToAddDocTypeSelected) {
                    return { valid: false, message: "Debe seleccionar un tipo de documento." };
                }

                val = String(val || "").trim();
                let numericVal = val.replace(/\D/g, "");

                if (this.personToAddDocTypeSelected.id === 'D') {
                    if (numericVal.length !== 7 && numericVal.length !== 8) {
                        this.searchButtonDisable = true;
                        message = numericVal.length > 0 ? "La cantidad de dígitos es incorrecta." : "Este campo es obligatorio.";
                        valid = false;
                    } else {
                        if (this.numDocExisting !== numericVal) {
                            this.numDocChange = true;
                            this.numDocExisting = numericVal;
                        }
                        this.searchButtonDisable = false;
                        message = "";
                        valid = true;
                    }
                } else if (this.personToAddDocTypeSelected.id === 'J') {
                    if (numericVal.length !== 11 || !this.validarCuit(numericVal)) {
                        message = "CUIT inválido. Debe tener 11 dígitos y comenzar con 30, 33 o 34";
                        valid = false;
                        this.searchButtonDisable = true;
                    } else {
                        this.searchButtonDisable = false;
                        message = "";
                        valid = true;
                    }
                } else {
                    this.searchButtonDisable = false;
                }

                if (!val) {
                    this.searchButtonDisable = true;
                }

                return { valid, message };
            };
        },
        methods: {
            validarCuit(cuit) {
                if (!/^\d{11}$/.test(cuit)) return false;
                const prefix = cuit.substring(0, 2);
                if (!["30", "33", "34"].includes(prefix)) return false;
                const mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                let total = 0;
                for (let i = 0; i < 10; i++) total += parseInt(cuit[i]) * mult[i];
                let resto = total % 11;
                let digito = resto === 0 ? 0 : resto === 1 ? 9 : 11 - resto;
                return digito === parseInt(cuit[10]);
            },
            getDefaultPerson() {
                return {
                    id: 0,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docType: { name: "" },
                    rol: { name: "" },
                    birthday: null,
                    beneficiariesList: []
                };
            },
            getDefaultPersonToAdd() {
                return {
                    isPersonExist: false,
                    activeForm: false,
                    birthday: null,
                    isBirthdayCorrect: true,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docTypeSelected: null,
                    email: "",
                    selectedIvaCondition: null,
                    areaCode: "",
                    telephone: null,
                    hasLocality: false,
                    MaximDigitSuperatedDni: false,
                    age: "",
                    selectedLocality: null,
                    address: null,
                    activeFormPersonNotExist: false,
                    alreadyExists: false,
                    beneficiaries: null
                };
            },
            getAgeGroup(birthday) {
                const age = this.getAgeAtTripEnd(birthday);
                if (age === null) return null;
                if (age < 21) return 'under21';
                if (age <= 75) return 'between21And75';
                return 'over75';
            },
            isOverMaxAge(birthday) {
                const age = this.getAgeAtTripEnd(birthday);
                return age !== null && age > MAX_PASSENGER_AGE;
            },
            getAgeAtTripEnd(birthday) {
                if (!birthday) return null;
                // La edad se calcula a la fecha de FIN del viaje (returnDate); si no está disponible, a hoy.
                let referenceDate = new Date();
                if (this.tripEndDate) {
                    const tripEnd = new Date(this.tripEndDate);
                    if (!isNaN(tripEnd.getTime())) referenceDate = tripEnd;
                }
                let bd;
                if (typeof birthday === 'string') {
                    const cleaned = birthday.replace(/^"|"$/g, '');
                    if (cleaned.includes('T') || cleaned.includes('-')) {
                        bd = new Date(cleaned);
                    } else if (cleaned.includes('/')) {
                        bd = new Date(cleaned.split('/').reverse().join('/'));
                    } else {
                        bd = new Date(cleaned);
                    }
                } else {
                    bd = new Date(birthday);
                }
                if (isNaN(bd.getTime())) return null;
                let age = referenceDate.getFullYear() - bd.getFullYear();
                const m = referenceDate.getMonth() - bd.getMonth();
                if (m < 0 || (m === 0 && referenceDate.getDate() < bd.getDate())) age--;
                return age;
            },
            formatDate(date) {
                if (!date) return '';
                let d;
                if (typeof date === 'string') {
                    const cleaned = date.replace(/^"|"$/g, '');
                    if (cleaned.includes('T') || cleaned.includes('-')) {
                        const parts = cleaned.split('T')[0].split('-');
                        return `${parts[2]}/${parts[1]}/${parts[0]}`;
                    }
                    d = new Date(cleaned);
                } else {
                    d = new Date(date);
                }
                if (isNaN(d.getTime())) return '';
                return d.getDate().toString().padStart(2, '0') + '/' + (d.getMonth() + 1).toString().padStart(2, '0') + '/' + d.getFullYear();
            },
            openCancelModal() { this.$refs.cancelModal.open(); },
            closeCancelModal() { this.$refs.cancelModal.close(); },
            cancelAndRedirect() {
                this.closeCancelModal();
                this.$router.push({ name: 'travelAssistance-tab-One' });
            },
            closeDeleteAssuredModal() {
                this.$refs.deleteAssuredModal.close();
                this.personToDelete = this.getDefaultPerson();
            },
            openDeleteAssuredModal(item: any) {
                this.personToDelete = { ...item };
                this.$refs.deleteAssuredModal.open();
            },
            openSelectMultiplePeopleModal(peopleList: any[]) {
                this.isPeopleWithSameIdentifierModalOpen = true;
                this.resetMultiplePeopleModalValues();
                let idCounter = 1;
                this.multiplePeopleWithSameIdentifier = peopleList.map(person => ({
                    id: idCounter++,
                    birthday: person.birthday,
                    firstName: person.firstName,
                    lastName: person.lastName,
                    email: person.email,
                    selectedIvaCondition: person.ivaConditionFiscalId,
                    areaCode: person.phoneAreaCode,
                    telephone: person.phoneNumber,
                    hasLocality: person.hasLocality,
                    address: person.address ? { ...person.address } : null,
                    document: person.document || null,
                    localityName: person.localityName
                }));
                this.$refs.selectMultiplePeopleModal.open();
            },
            resetMultiplePeopleModalValues() {
                this.multiplePeopleWithSameIdentifier = [];
                this.personWithSameIdentifierSelected = null;
                this.multiplePeopleError = "";
            },
            closeSelectMultiplePeopleModal(flag = true) {
                this.isPeopleWithSameIdentifierModalOpen = false;
                this.resetMultiplePeopleModalValues();
                if (flag) this.resetPersonToAddModal();
                this.$refs.selectMultiplePeopleModal.close();
            },
            resetPersonToAddModal() {
                this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.name && p.name.trim() === "DNI") || null;
                this.personToAddNumDoc = "";
                this.personToAdd = this.getDefaultPersonToAdd();
            },
            onSelectedClient(id: number) {
                this.personWithSameIdentifierSelected = id;
                const selectedPerson = this.multiplePeopleWithSameIdentifier.find(item => item.id === this.personWithSameIdentifierSelected);
                if (!selectedPerson) return;

                if (this.isBeneficiaryMode) {
                    const list = this.currentBeneficiaryItem.beneficiariesList || [];
                    const dupInThis = list.some(b =>
                        b.docType.id === this.personToAddDocTypeSelected.id &&
                        b.docNum === this.personToAddNumDoc
                    );
                    const selfAsBene =
                        this.currentBeneficiaryItem.docType.id === this.personToAddDocTypeSelected.id &&
                        this.currentBeneficiaryItem.docNum === this.personToAddNumDoc;
                    if (dupInThis || selfAsBene) {
                        this.personToAdd.alreadyExists = true;
                        return;
                    }
                } else {
                    const alreadyInsured = this.insuredPeople.some(member =>
                        member.docType.id === this.personToAddDocTypeSelected.id &&
                        member.docNum === this.personToAddNumDoc
                    );
                    if (alreadyInsured) {
                        this.personToAdd.alreadyExists = true;
                        return;
                    }
                    // Validar edad máxima y cupo etario para asegurados
                    if (this.isOverMaxAge(selectedPerson.birthday)) {
                        this.multiplePeopleError = MAX_PASSENGER_AGE_MESSAGE;
                        return;
                    }
                    const grupo = this.getAgeGroup(selectedPerson.birthday);
                    if (!grupo || this.cuposRestantes[grupo] <= 0) {
                        this.multiplePeopleError = grupo
                            ? `Ya cargaste todos los pasajeros del rango ${GROUP_LABELS[grupo]}. Volvé a Datos del viaje para ajustar.`
                            : 'No se pudo determinar la edad del pasajero.';
                        return;
                    }
                }

                selectedPerson.beneficiaries = this.beneficiaries;
                this.setPersonToAdd(selectedPerson);

                if (this.personToAddNumDoc && !this.personToAdd.alreadyExists) {
                    this.personFound = true;
                }
                // Cerramos el modal múltiple sin resetear el de alta: vuelve a verse en estado confirmación
                this.closeSelectMultiplePeopleModal(false);
            },
            cancelMultiplePeopleSelection() {
                this.closeSelectMultiplePeopleModal(true);
                this.backToSearch();
            },
            deleteAssured(id: number) {
                const index = this.insuredPeople.findIndex(member => member.id === id);
                if (index !== -1) this.insuredPeople.splice(index, 1);
                this.closeDeleteAssuredModal();
            },
            closePersonToAddModal() {
                this.$refs.personToAddModal.close();
                if (!this.isPeopleWithSameIdentifierModalOpen) {
                    this.resetPersonModalState();
                }
                const IdCUIT = this.documentTypeList.findIndex(dt => dt.id === 'J');
                if (IdCUIT !== -1) this.documentTypeList.splice(IdCUIT, 1);
            },
            openPersonToAddModal() {
                this.resetPersonModalState();
                this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.name && p.name.trim() === "DNI") || null;
                this.$refs.personToAddModal.open();
            },
            addInsured() {
                this.beneficiaries = 'legalHeirs';
                this.isBeneficiaryMode = false;
                const IdCUIT = this.documentTypeList.findIndex(dt => dt.id === 'J');
                if (IdCUIT !== -1) this.documentTypeList.splice(IdCUIT, 1);
                this.openPersonToAddModal();
            },
            addBeneficiaries(item) {
                const existeJ = this.documentTypeList.some((p: any) => p.id === 'J');
                if (!existeJ) {
                    this.documentTypeList.push({ id: 'J', text: 'CUIT', name: "CUIT" });
                }
                this.isBeneficiaryMode = true;
                this.currentBeneficiaryItem = item;
                this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.name && p.name.trim() === "DNI") || null;
                this.personToAddNumDoc = "";
                this.personFound = false;
                this.personNotExist = false;
                this.messageErrorAge = null;
                this.personToAdd = this.getDefaultPersonToAdd();
                this.$refs.personToAddModal.open();
            },
            removeBeneficiary(insuredItem, index) {
                insuredItem.beneficiariesList.splice(index, 1);
            },
            saveBeneficiary() {
                const docId = this.personToAddDocTypeSelected.id;

                if (docId === 'J') {
                    if (!this.personToAdd.lastName) {
                        NF.Notification.show({
                            type: NF.Notification.Type.ERROR,
                            title: "Error",
                            content: "Complete el nombre de la razón social.",
                            autoHideDelay: 5000
                        });
                        return;
                    }
                } else {
                    if (!this.personToAdd.firstName || !this.personToAdd.lastName) {
                        NF.Notification.show({
                            type: NF.Notification.Type.ERROR,
                            title: "Error",
                            content: "Complete el nombre y apellido del beneficiario.",
                            autoHideDelay: 5000
                        });
                        return;
                    }
                }
                if (!Array.isArray(this.currentBeneficiaryItem.beneficiariesList)) {
                    this.currentBeneficiaryItem.beneficiariesList = [];
                }

                const docTypeFound = this.documentTypeList.find((dt: any) => dt.id === docId);

                this.beneficiaryData = {
                    birthday: this.personToAdd.birthday,
                    docNum: this.personToAdd.docNum,
                    docType: { id: docId, name: docTypeFound.text },
                    firstName: this.personToAdd.firstName,
                    lastName: this.personToAdd.lastName,
                    selectedIvaCondition: this.personToAdd.selectedIvaCondition ? this.personToAdd.selectedIvaCondition.id : null,
                    zipCode: this.personToAdd.locality ? this.personToAdd.locality.split(' ').pop() : null
                };

                if (!this.personToAdd.hasLocality) {
                    this.peopleToCoverHasLocality = false;
                    this.hasBeneficiaryAddress = true;
                    this.personFound = false;
                    this.openAdressModal();
                    this.$refs.personToAddModal.close();
                } else {
                    this.peopleToCoverHasLocality = true;
                    this.hasBeneficiaryAddress = false;
                    this.currentBeneficiaryItem.beneficiariesList.push(this.beneficiaryData);
                    this.personToAdd = this.getDefaultPersonToAdd();
                    this.isBeneficiaryMode = false;
                    this.personFound = false;
                    this.$refs.personToAddModal.close();
                }
            },
            isPersonToAddSelectedDocumentType() {
                this.isNotSelectedDocumentType = false;
                if (this.personToAddDocTypeSelected) {
                    if (this.personToAddDocTypeSelected.name !== "CUIT") {
                        this.isPerson = true;
                        this.isJuridico = false;
                    } else {
                        this.isJuridico = true;
                        this.isPerson = false;
                    }
                }
                this.personToAddNumDoc = "";
                this.personToAdd = this.getDefaultPersonToAdd();
            },
            anterior() {
                sessionStorage.setItem("pressBackFromPassengers", "true");
                this.$router.push({ name: 'travelAssistance-policyOwner' });
            },
            siguiente() {
                // Validar que todos los pasajeros en modo 'others' tengan su beneficiario único cargado
                const personsRequiringBenef = this.insuredPeople.filter(item => item.beneficiaries === "others");
                const allHaveBenef = personsRequiringBenef.every(item =>
                    Array.isArray(item.beneficiariesList) && item.beneficiariesList.length > 0
                );
                if (!allHaveBenef) {
                    NF.Notification.show({
                        type: NF.Notification.Type.ERROR,
                        title: "Error",
                        content: "Debe agregar al menos un beneficiario para cada pasajero que lo requiera.",
                        autoHideDelay: 5000
                    });
                    this.pushGtmError('errorUsuario');
                    return;
                }
                // Validar que se complete la cantidad total declarada
                if (this.insuredPeople.length !== this.totalPassengersDeclared) {
                    NF.Notification.show({
                        type: NF.Notification.Type.ERROR,
                        title: "Error",
                        content: "Debe completar el total de pasajeros declarado (" + this.totalPassengersDeclared + ").",
                        autoHideDelay: 5000
                    });
                    this.pushGtmError('errorUsuario');
                    return;
                }
                sessionStorage.setItem("passengers", JSON.stringify(this.insuredPeople));
                this.$router.push({ name: 'travelAssistance-Summary' });
            },
            pushGtmError(eventName) {
                var contratante = JSON.parse(sessionStorage.getItem("contratante"));
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': contratante ? contratante.email : null,
                    'referente': this.referente,
                    'product': 'asistencia-viaje',
                    'event': eventName,
                    'paso': 'cotizador-asistencia-viaje-datos-viajant'
                });
            },
            getDocumentType() {
                return documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length) {
                        this.documentTypeList = response.map((element: any) => ({
                            ...element,
                            id: element["id"].trim(),
                            text: element["name"].trim()
                        }));
                        this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.name.trim() === "DNI") || null;
                    }
                }).catch(error => {
                    this.pushGtmError('errorServidor');
                    throw error;
                });
            },
            getIvaConditions() {
                ivaConditionService.getIvaConditionsList().then(response => {
                    if (response.length) {
                        this.ivaConditionList = response.map((element: any) => ({
                            ...element,
                            id: element["id"].toString(),
                            text: element["name"]
                        }));
                    }
                }).catch(() => {
                    this.pushGtmError('errorServidor');
                });
            },
            setPersonToAdd(personToAdd: any) {
                this.personToAdd.activeFormPersonNotExist = false;
                this.personToAdd.isPersonExist = true;
                this.personToAdd.activeForm = true;
                this.personToAdd.docNum = this.personToAddNumDoc;
                this.personToAdd.docType = this.documentTypeList.find((p: any) => p.id.trim() === personToAdd.document.identificationTypeCode);
                this.personToAdd.birthday = personToAdd.birthday;
                this.personToAdd.firstName = personToAdd.firstName;
                this.personToAdd.lastName = personToAdd.lastName;
                this.personToAdd.email = personToAdd.email || "";
                this.personToAdd.selectedIvaCondition = personToAdd.ivaConditionFiscalId
                    ? this.ivaConditionList.find((o: any) => o.id == personToAdd.ivaConditionFiscalId || o.name == personToAdd.ivaConditionFiscalId)
                    : this.ivaConditionList.find((o: any) => o.id == 4 || o.name === "Consumidor Final");
                this.personToAdd.areaCode = personToAdd.phoneAreaCode ? personToAdd.phoneAreaCode.replace(/^0+/, '') : "";
                this.personToAdd.telephone = personToAdd.phoneNumber ? personToAdd.phoneNumber.replace(/^15+/, '') : null;
                this.personToAdd.hasLocality = personToAdd.hasLocality;
                this.personToAdd.beneficiaries = personToAdd.beneficiaries;
                if (personToAdd.address) this.personToAdd.address = { ...personToAdd.address };
                if (personToAdd.document) this.personToAdd.document = personToAdd.document;
                this.personToAdd.locality = personToAdd.localityName;
            },
            searchPersonToAdd() {
                NF.UI.Page.blockCustom({ message: 'Cargando datos...' });
                this.personNotExist = false;
                this.messageErrorAge = "";

                this.personToAdd = { ...this.getDefaultPersonToAdd(), beneficiaries: '' };

                if (this.isBeneficiaryMode) {
                    const listaCurr = this.currentBeneficiaryItem.beneficiariesList || [];
                    const dupEnEsta = listaCurr.some(b =>
                        b.docType.id === this.personToAddDocTypeSelected.id &&
                        b.docNum === this.personToAddNumDoc
                    );
                    const selfAsBene =
                        this.currentBeneficiaryItem.docType.id === this.personToAddDocTypeSelected.id &&
                        this.currentBeneficiaryItem.docNum === this.personToAddNumDoc;
                    this.personToAdd.alreadyExists = dupEnEsta || selfAsBene;
                } else {
                    this.personToAdd.alreadyExists = this.insuredPeople.some(member =>
                        member.docType.id === this.personToAddDocTypeSelected.id &&
                        member.docNum === this.personToAddNumDoc
                    );
                }

                if (this.personToAdd.alreadyExists) {
                    NF.UI.Page.unblock();
                    return;
                }

                if (this.personToAddNumDoc) {
                    const dni = this.personToAddNumDoc;

                    searchPersonService
                        .GetSearchPersonData(dni, this.personToAddDocTypeSelected.id, false)
                        .then(response => {
                            if (response.searchPersonResult.length > 1) {
                                this.openSelectMultiplePeopleModal(response.searchPersonResult);
                                return;
                            }
                            if (response.searchPersonResult.length < 1) {
                                this.personNotExist = true;
                                return;
                            }
                            const result = response.searchPersonResult[0];
                            if (result && (result.firstName || result.razonSocial || (result.document.identificationTypeCode === "J" && result.lastName))) {
                                this.setPersonToAdd(result);

                                // validar cupo etario (solo pasajeros, no beneficiarios)
                                if (!this.isBeneficiaryMode) {
                                    const grupo = this.getAgeGroup(result.birthday);
                                    if (!grupo) {
                                        this.messageErrorAge = 'No se pudo determinar la edad del pasajero.';
                                        this.personToAdd.isBirthdayCorrect = false;
                                        return;
                                    }
                                    if (this.isOverMaxAge(result.birthday)) {
                                        this.messageErrorAge = MAX_PASSENGER_AGE_MESSAGE;
                                        this.personToAdd.isBirthdayCorrect = false;
                                        return;
                                    }
                                    if (this.cuposRestantes[grupo] <= 0) {
                                        this.messageErrorAge = `Ya cargaste todos los pasajeros del rango ${GROUP_LABELS[grupo]}. Volvé a Datos del viaje para ajustar.`;
                                        this.personToAdd.isBirthdayCorrect = false;
                                        return;
                                    }
                                    this.messageErrorAge = '';
                                    this.personToAdd.isBirthdayCorrect = true;
                                }
                            } else {
                                // No se permite carga manual: si no existe en BUP, se bloquea con mensaje.
                                this.personToAdd.isPersonExist = false;
                                this.personNotExist = true;
                            }
                        })
                        .catch(error => {
                            this.pushGtmError('errorServidor');
                            throw error;
                        })
                        .finally(() => {
                            NF.UI.Page.unblock();
                            if (!this.isPeopleWithSameIdentifierModalOpen && this.personToAdd.isPersonExist && this.personToAdd.isBirthdayCorrect) {
                                this.personFound = true;
                            }
                        });
                } else {
                    this.personToAddNumDoc = null;
                    NF.UI.Page.unblock();
                }
            },
            confirmPerson() {
                if (this.personToAdd && this.personToAdd.isPersonExist && this.personToAdd.isBirthdayCorrect) {
                    if (this.isBeneficiaryMode) {
                        this.saveBeneficiary();
                    } else {
                        this.addOrEditPerson();
                    }
                }
            },
            backToSearch() {
                this.personFound = false;
                this.personNotExist = false;
                this.messageErrorAge = null;
                this.personToAddNumDoc = "";
                this.personToAdd = this.getDefaultPersonToAdd();
            },
            addOrEditPerson() {
                this.personData = {
                    beneficiaries: this.beneficiaries,
                    beneficiariesList: [],
                    id: this.insuredPeople.length ? Math.max(...this.insuredPeople.map(p => p.id)) + 1 : 1,
                    isPersonExist: this.personToAdd.isPersonExist,
                    birthday: this.personToAdd.birthday,
                    firstName: this.personToAdd.firstName,
                    lastName: this.personToAdd.lastName,
                    docNum: this.personToAdd.docNum,
                    docType: this.personToAdd.docType,
                    email: this.personToAdd.email,
                    selectedIvaCondition: this.personToAdd.selectedIvaCondition ? this.personToAdd.selectedIvaCondition.id : null,
                    areaCode: this.personToAdd.areaCode,
                    telephone: this.personToAdd.telephone,
                    hasLocality: this.personToAdd.hasLocality,
                    MaximDigitSuperatedDni: this.personToAdd.MaximDigitSuperatedDni,
                    age: this.personToAdd.age,
                    selectedLocality: this.personToAdd.selectedLocality,
                    address: null,
                    rol: this.rolRelations,
                    isContractor: false,
                    zipCode: this.personToAdd.locality ? this.personToAdd.locality.split(' ').pop() : null
                };
                this.personToAddNumDoc = null;

                if (!this.personData.hasLocality) {
                    this.peopleToCoverHasLocality = false;
                    this.closePersonToAddModal();
                    this.openAdressModal();
                } else {
                    this.peopleToCoverHasLocality = true;
                    this.insuredPeople.push(this.personData);
                    this.closePersonToAddModal();
                }
            },
            addAdressToPerson() {
                const address = {
                    StreetName: this.streetName,
                    StreetNumber: this.numDom,
                    City: { CityPostalCode: this.selectedLocality.zipCode }
                };

                if (!this.isBeneficiaryMode) {
                    this.personData.zipCode = this.selectedLocality.zipCode;
                    this.personData.hasLocality = true;
                    this.personData.address = address;
                    this.insuredPeople.push(this.personData);
                } else {
                    this.beneficiaryData.zipCode = this.selectedLocality.zipCode;
                    this.beneficiaryData.cityCode = this.selectedLocality.id;
                    this.beneficiaryData.hasLocality = true;
                    this.beneficiaryData.address = address;
                    this.currentBeneficiaryItem.beneficiariesList.push(this.beneficiaryData);
                    this.isBeneficiaryMode = false;
                    this.beneficiaryData = {};
                }
                this.personToAdd = this.getDefaultPersonToAdd();
                this.closeAdressModal();
            },
            openAdressModal() { this.$refs.addresToAddModal.open(); },
            closeAdressModal() {
                this.$refs.addresToAddModal.close();
                this.streetName = null;
                this.numDom = null;
                this.selectedLocality = null;
                this.piso = null;
                this.numDept = null;
            },
            resetPersonModalState() {
                this.personToAdd = this.getDefaultPersonToAdd();
                this.personToAddNumDoc = "";
                this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.name === "DNI") || null;
                this.searchButtonDisable = true;
                this.personNotExist = false;
                this.personFound = false;
                this.messageErrorAge = null;
                this.isBeneficiaryMode = false;
                this.beneficiaries = "legalHeirs";
                this.currentBeneficiaryItem = null;
                this.multiplePeopleWithSameIdentifier = [];
                this.personWithSameIdentifierSelected = null;
                this.multiplePeopleError = "";
            },
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                const actualStep = 'pasajeros';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                } catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit('show-service-fail', statusCode, [() => this.pageCustomization()]);
                }
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            loadPlanData() {
                const planData = sessionStorage.getItem("SelectedTravelPlan");
                if (planData) {
                    const plan = JSON.parse(planData);
                    this.planDescription = plan.name;
                    this.planPrice = plan.priceFormatted;
                    this.planPriceArs = plan.priceArsFormatted || '';
                    this.covers = plan.covers || [];
                }
                const travelData = sessionStorage.getItem("TravelDetailsData");
                if (travelData) {
                    const td = JSON.parse(travelData);
                    this.cuposDeclarados = {
                        under21: td.passengersUnder21 || 0,
                        between21And75: td.passengersBetween21And75 || 0,
                        over75: td.passengersOver75 || 0,
                    };
                    // Fecha de fin del viaje: la edad/grupo etario se calcula a esta fecha (no a hoy).
                    this.tripEndDate = td.returnDate || null;
                }
            },
            getContractorDocType(contratante) {
                const bupDocTypeId = contratante.document && contratante.document.identificationTypeCode
                    ? String(contratante.document.identificationTypeCode).trim()
                    : null;
                if (bupDocTypeId) {
                    const found = this.documentTypeList.find((dt: any) => dt.id === bupDocTypeId);
                    return { id: bupDocTypeId, name: found ? found.text : bupDocTypeId };
                }
                const combo = contratante.documentType || null;
                return combo
                    ? { id: combo.id, name: combo.name || combo.text }
                    : { id: 'D', name: 'DNI' };
            },
            preloadContractorIfTraveling() {
                const contractorTravelingRaw = sessionStorage.getItem("contractorTraveling");
                this.contractorTraveling = contractorTravelingRaw ? JSON.parse(contractorTravelingRaw) : false;
                const contratante = JSON.parse(sessionStorage.getItem("contratante") || "null");
                this.policyOwner = contratante;
                if (!this.contractorTraveling || !contratante) return;

                // Beneficiarios elegidos para el contratante en policyOwner ('legalHeirs' | 'others').
                const contractorBeneficiariesRaw = sessionStorage.getItem("contractorBeneficiaries");
                const contractorBeneficiaries = contractorBeneficiariesRaw ? JSON.parse(contractorBeneficiariesRaw) : 'legalHeirs';

                const birthday = contratante.birthday || contratante.birthDay || null;
                const grupo = this.getAgeGroup(birthday);
                this.groupOfContractor = grupo;

                // La validación del rango etario del contratante se hace en policyOwner (al cargar el tomador).
                // Acá solo evitamos cargarlo si quedara en un estado inconsistente, sin volver a notificar ni bloquear.
                if (!grupo || this.cuposDeclarados[grupo] <= 0) {
                    return;
                }

                const docType = this.getContractorDocType(contratante);

                const contractorAsPassenger = {
                    beneficiaries: contractorBeneficiaries,
                    beneficiariesList: [],
                    id: this.insuredPeople.length ? Math.max(...this.insuredPeople.map(p => p.id)) + 1 : 1,
                    isPersonExist: true,
                    birthday: birthday,
                    firstName: contratante.firstName,
                    lastName: contratante.lastName,
                    docNum: contratante.documentNumber || (contratante.document ? contratante.document.identificationNumber : ''),
                    docType: docType,
                    email: contratante.email,
                    selectedIvaCondition: contratante.ivaCondition ? contratante.ivaCondition.id : (contratante.ivaConditionFiscalId || null),
                    areaCode: contratante.areaCode,
                    telephone: contratante.telephone,
                    // Si el tomador cargó su dirección en Datos del Contratante (no la tenía en BUP),
                    // el asegurado-contratante la lleva con el mismo formato que un pasajero del modal.
                    hasLocality: contratante.addresFromFront === true
                        ? true
                        : (contratante.hasLocality !== undefined ? contratante.hasLocality : true),
                    address: contratante.addresFromFront === true
                        ? { StreetName: contratante.streetName, StreetNumber: contratante.numDom }
                        : (contratante.address || null),
                    rol: this.rolRelations,
                    isContractor: true,
                    zipCode: contratante.zipCode || null,
                };

                this.insuredPeople.push(contractorAsPassenger);
            },
            restorePassengersFromSession() {
                const saved = sessionStorage.getItem("passengers");
                if (!saved) return false;
                try {
                    const parsed = JSON.parse(saved);
                    if (Array.isArray(parsed) && parsed.length) {
                        this.insuredPeople = parsed;
                        return true;
                    }
                } catch (e) {

                }
                return false;
            },

            reconcileContractorPassenger() {
                const contractorTravelingRaw = sessionStorage.getItem("contractorTraveling");
                this.contractorTraveling = contractorTravelingRaw ? JSON.parse(contractorTravelingRaw) : false;
                const contratante = JSON.parse(sessionStorage.getItem("contratante") || "null");
                this.policyOwner = contratante;

                const idx = this.insuredPeople.findIndex(p => p.isContractor);

                // contratante NO viaje: si quedó cargado como pasajero se saca 
                if (!this.contractorTraveling || !contratante) {
                    if (idx !== -1) this.insuredPeople.splice(idx, 1);
                    return;
                }

                // Antes no viajaba y ahora sí, lo cargamos
                if (idx === -1) {
                    this.preloadContractorIfTraveling();
                    return;
                }

                // Ya estaba cargado se sincroniza la eleccion de beneficiarios hecha en policyOwner
                const contractorBeneficiariesRaw = sessionStorage.getItem("contractorBeneficiaries");
                const contractorBeneficiaries = contractorBeneficiariesRaw ? JSON.parse(contractorBeneficiariesRaw) : 'legalHeirs';

                const current = this.insuredPeople[idx];
                if (current.beneficiaries !== contractorBeneficiaries) {
                    current.beneficiaries = contractorBeneficiaries;
                    // Si paso a 'legalHeirs' el beneficiario es placeholder -> se limpia la lista manual
                    if (contractorBeneficiaries === 'legalHeirs') {
                        current.beneficiariesList = [];
                    }
                }

                current.docType = this.getContractorDocType(contratante);

                const birthday = contratante.birthday || contratante.birthDay || null;
                this.groupOfContractor = this.getAgeGroup(birthday);
            },
        },
        watch: {
            insuredPeople() {
                if (this.insuredPeople.length >= this.totalPassengersDeclared) {
                    this.addPeopleDisable = true;
                    this.addPeopleDisableTooltipText = `Ya cargaste los ${this.totalPassengersDeclared} pasajeros declarados.`;
                } else {
                    this.addPeopleDisable = false;
                    this.addPeopleDisableTooltipText = "";
                }
                this.nextButtonDisable = this.insuredPeople.length !== this.totalPassengersDeclared;
            },
            personToAddNumDoc() {
                // Los mensajes son de la búsqueda anterior: si cambia el documento dejan de aplicar
                this.messageErrorAge = null;
                this.personNotExist = false;
                this.personToAdd.alreadyExists = false;
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const referente = sessionStorage.getItem("Referente");
                this.referente = (referente === 'null' || referente == null) ? null : referente;

                await this.pageCustomization();
                this.updateByProductGoogleAnalytics();
                await this.getDocumentType();
                this.getIvaConditions();
                this.loadPlanData();

                const restored = this.restorePassengersFromSession();
                if (restored) {
                    this.reconcileContractorPassenger();
                } else {
                    this.preloadContractorIfTraveling();
                }

                sessionStorage.setItem("ExitOrContinueModal", "true");

                const contratante = JSON.parse(sessionStorage.getItem("contratante"));
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': contratante ? contratante.email : null,
                    'referente': this.referente,
                    'product': 'asistencia-viaje',
                    'event': 'cotizador-asistencia-viaje-datos-viajant'
                });
                window.globalThis._qsie = window.globalThis._qsie || [];
                window.globalThis._qsie.push('cotizador-asistencia-viaje-datos-viajant');
            } finally {
                NF.UI.Page.unblock();
            }
        }
    });
